import { useNetworkMutation } from '@/lib/utils/request'

export const useDeleteTaskAssignment = (taskId: string, taskAssignmentId: string) =>
  useNetworkMutation({
    url: `/v1/tasks/${taskId}/assignments/${taskAssignmentId}/`,
    method: 'delete',
  })
